import { Component, inject } from '@angular/core';
import { ListViewProviderDirective, NtapGlobalConstants } from '@ntap/core';
import { first, tap } from 'rxjs';

@Component({
  selector: `app-odabir-povezane-osobe`,
  templateUrl: './odabir-povezane-osobe.component.html'
})
export class OdabirPovezaneOsobeComponent {
  public showDialog = false;

  private listviewProvider = inject(ListViewProviderDirective);

  public refresh() {
    this.listviewProvider.refresh();
  }

  public onSelectedItem(osobe: any[]) {
    let id = 0;
    this.listviewProvider.view$
      .pipe(
        first(),
        tap((view) => {
          const parentPismenoId = (
            this.listviewProvider.viewState as {
              'seup~pismeno~id': number;
            }
          )['seup~pismeno~id'];

          osobe.forEach((osoba) => {
            let naziv = '';
            if (osoba['seup~subjekt~naziv']) {
              naziv = osoba['seup~subjekt~naziv'];
            } else if (
              !!osoba['seup~subjekt~ime'] &&
              !!osoba['seup~subjekt~prezime']
            ) {
              naziv =
                osoba['seup~subjekt~ime'] + ' ' + osoba['seup~subjekt~prezime'];
            } else {
              naziv = '';
            }
            const newItem: any = {
              'seup~osoba~id': id,
              'seup~subjekt~naziv': naziv,
              'seup~osoba~pismeno_id': parentPismenoId,
              'seup~osoba~subjekt_id': osoba['seup~subjekt~id']
            };

            const updateItem: any = {
              'seup~osoba~id': id,
              'seup~osoba~pismeno_id': parentPismenoId,
              'seup~osoba~subjekt_id': osoba['seup~subjekt~id'],
              $itemType: 'seup~osoba'
            };

            id--;
            newItem[NtapGlobalConstants.ATTR_$itemType] = view.$mainType;
            this.listviewProvider.addItem(newItem);
            this.listviewProvider.updateItem(updateItem, 0);
          });
        })
      )
      .subscribe();

    this.showDialog = false;
  }
}
